import { useEffect, useRef, useState } from 'react'

/** Aligns with ThumbnailSidebarContainer width transition. */
export const THUMBNAIL_SIDEBAR_OPEN_TRANSITION_MS = 350

export function useThumbnailSidebarOpenTransition(
  isOpen: boolean,
  onSettled: () => void
): boolean {
  const [openLayoutSettled, setOpenLayoutSettled] = useState(isOpen)
  const previousOpenState = useRef(isOpen)
  const onSettledRef = useRef(onSettled)
  onSettledRef.current = onSettled

  useEffect(() => {
    if (!isOpen) {
      setOpenLayoutSettled(false)
    }

    const openChanged = previousOpenState.current !== isOpen
    previousOpenState.current = isOpen

    const timeoutId = window.setTimeout(() => {
      if (isOpen) {
        setOpenLayoutSettled(true)
      }
      if (!openChanged) return
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          onSettledRef.current()
        })
      })
    }, THUMBNAIL_SIDEBAR_OPEN_TRANSITION_MS)

    return () => window.clearTimeout(timeoutId)
  }, [isOpen])

  return openLayoutSettled
}
